import Vue from 'vue'

Vue.filter('round', (v) => Math.round(v))
